// extracted by mini-css-extract-plugin
export default {"popup":"ConfirmationPopup__popup--K1t","inner":"ConfirmationPopup__inner--5pB","content":"ConfirmationPopup__content--31S","btn":"ConfirmationPopup__btn--1lU"};